import { Link } from "react-router-dom";
import BrainIcon from "../../assets/icons/brain-green.svg?react";
import { DEFAULT_LANGUAGE } from "../../config/i18n";
import { useActiveLang } from "../../domains/app/hooks/useActiveLang";
import { EventDisplayDestination } from "../../../../api/src/shared/domain/room";
import { useApiQuery } from "../../services/api";
import { RoomBlockHeading } from "./layout";
import { useTranslation } from "react-i18next";

export default function RoomEventDisplay({
  roomId,
  roomTextColor,
  pageType,
  conferenceIds,
}: {
  roomId: string;
  roomTextColor: string | null;
  pageType: EventDisplayDestination;
  conferenceIds?: string[] | undefined;
}) {
  const { activeLang } = useActiveLang();
  const { t } = useTranslation();

  const result = useApiQuery("/webapp/private/rooms/:id/events", {
    param: { id: roomId },
  });

  if (result.state !== "success") return null;

  const displayedEvents = result.body
    .filter((event) => event.destinations.includes(pageType))
    .filter(
      (event) =>
        pageType !== EventDisplayDestination.CONGRESS ||
        conferenceIds === undefined ||
        (event.congress !== null && conferenceIds.includes(event.congress))
    );

  if (displayedEvents.length === 0) return null;

  return (
    <>
      <RoomBlockHeading
        style={{ color: roomTextColor === null ? undefined : roomTextColor }}
      >
        <BrainIcon />
        {t("Test your knowledge")}
      </RoomBlockHeading>

      <div className="px-2 pb-4 flex flex-col gap-4">
        {displayedEvents.map((event) => {
          const translation =
            event.translations?.[activeLang] ??
            event.translations?.[DEFAULT_LANGUAGE];
          const eventName = translation?.eventName ?? "";
          const eventImage = translation?.image;

          if (!eventImage?.url) return null;

          return (
            <Link key={event.id} to={`/room/quiz/${roomId}?event=${event.id}`}>
              <img
                src={eventImage.url}
                alt={eventName}
                className="max-w-full h-auto rounded-2xl"
              />
            </Link>
          );
        })}
      </div>
    </>
  );
}
